///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthReactiveInputBase } from './input-base';
import { GtthInputTypesEnum } from './input-types.enum';

export class GtthReactiveCheckbox extends GtthReactiveInputBase<boolean> {
    controlType = GtthInputTypesEnum.CHECKBOX;
    checkboxLabel: string;
    displayValue: string;

    constructor(options: GtthReactiveCheckbox) {
        super(options);
        this.checkboxLabel = options.checkboxLabel || '';
        this.displayValue = options.displayValue || '';
    }
}
